// services/loanRequestFile.service.ts
import request from '../../axios';

const postUploadCreditLoanImg = async (
  payload: ILoanRequestFilePayload,
): Promise<ILoanRequestFileResponse> => {
  const formData = new FormData();
  formData.append('loan_request', payload.loan_request);
  formData.append('loan_rule', payload.loan_rule);
  formData.append('loan_document', payload.loan_document);
  formData.append('file', payload.file);

  const response = await request.post(
    `/api/v2/payment/loan-request-file`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response.data;
};

export default postUploadCreditLoanImg;
